export const checkhqBaseUrl = "/checkhq/router";
